import React from 'react'
import { useSelector } from 'react-redux'

import { Field } from 'formik'

import { H5 } from '@driftt/tide-core'

import useSubscriptionsBySections from '../../../hooks/useSubscriptionsBySections'
import { getHasAbility } from '../../../selectors'
import { NotificationValue } from '../../../typings/notificationPayload'
import { specifiedArraySort } from '../../../utils'
import C from '../constants'
import CheckboxRow from '../form/CheckboxRow'
import LoadingFieldList from '../form/LoadingFieldList'
import SelectCheckboxRow from '../form/SelectCheckboxRow'

const ConversationNotificationSection: React.FC = () => {
  const {
    notificationSubscriptions,
    loadingSectionNotificationPreferences,
    sectionNotificationPreferencesFailed,
    retrySectionsFetch
  } = useSubscriptionsBySections()
  const hasAllConversationsAccess = useSelector<any, boolean>(getHasAbility('hasAllConversations'))
  const hasNoParticipantsAccess = useSelector<any, boolean>(getHasAbility('hasNoParticipants'))
  const options = [{ label: 'My conversations', value: NotificationValue.MINE }]
  if (hasNoParticipantsAccess || hasAllConversationsAccess) {
    options.push({
      label: 'My conversations and no participants',
      value: NotificationValue.MINE_AND_UNASSIGNED
    })
  }

  if (hasAllConversationsAccess) {
    options.push({ label: 'All conversations', value: NotificationValue.ALL })
  }

  const sectionsToUse = Object.values(notificationSubscriptions).filter(({ title }) => !!title)

  const list = Object.values(sectionsToUse)
  const sortedSections = specifiedArraySort(list, C.SUBSCRIPTION_TYPES, 'type')

  return (
    <section>
      <H5>Conversations</H5>
      <LoadingFieldList
        loading={loadingSectionNotificationPreferences}
        failed={sectionNotificationPreferencesFailed}
        handleRetry={retrySectionsFetch}
        label="section">
        <>
          {sortedSections.map(({ subscriptionId, title, type }) => (
            <Field key={subscriptionId} name={`subscriptions.${subscriptionId}`}>
              {(props: any) => (
                <CheckboxRow
                  {...props}
                  content={type === 'all-convos' ? 'All conversations' : title}
                />
              )}
            </Field>
          ))}
        </>
      </LoadingFieldList>
      <Field name="properties.humane-notifications-email">
        {(props: any) => (
          <SelectCheckboxRow
            options={options}
            label="Send me email notifications every 15 minutes for"
            {...props}
          />
        )}
      </Field>
    </section>
  )
}

export default ConversationNotificationSection
